import { Link, useLocation } from "react-router-dom";

const routeLabels = {
  "/services": "Services",
  "/technology": "Technology",
  "/about": "Our Story",
  "/faq": "FAQ",
  "/quote": "Get a Quote",
};

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const current = routeLabels[pathname];
  if (!current) return null;

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <div className="container breadcrumb__inner">
        <Link to="/">Home</Link>
        <span aria-hidden="true">/</span>
        <span aria-current="page">{current}</span>
      </div>
    </nav>
  );
}
